<template>
  <div class="flex flex-col gap-3 text-sm leading-relaxed">
    <p v-if="hasNonEmptyOrders" class="font-medium text-destructive">
      {{ t("common.incomplete-bookings-warning") }}
    </p>
    <p>{{ t("cashfloat.userswitch-message") }}</p>
    <p class="font-semibold text-foreground">
      {{ t("common.confirm-signout") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import i18n from "@/lang";
import { hasNonEmptyOrders } from "@/utils/vue-helpers/orders.helper";

// =============================================================================
// State
// =============================================================================

// Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on i18n.global.t().
const t: (key: string, ...args: unknown[]) => string = (
  i18n.global as unknown as {
    t: (key: string, ...args: unknown[]) => string;
  }
).t;
</script>
